import React from 'react';
import {translate} from 'react-i18next';
import withAuthentication from './withAuthentication';

class UserButton extends React.PureComponent {

    render() {

        const {t, auth: {user}} = this.props;

        return (

            <button type="button" className={`btn btn-primary text-truncate ${this.props.className || ''}`} onClick={this.props.onClick}>
                {user ? (user.displayName || user.email) : t('userButton.login')}
            </button>
        );
    }
}

export default withAuthentication(translate()(UserButton));



// WEBPACK FOOTER //
// ./src/components/UserButton.js